var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="about_empty"> <div class="content-wrapper" data-help="custom"> <div class="row"> <div class="col-sm-9"> <div class="row"> <div class="col-sm-12 pr-0"> <h3 class="text-dark font-weight-bold mb-0 mr-5">'+
((__t=( resources['X200193'] ))==null?'':__t)+
'</h3> </div> </div> </div> </div> <div class="row mt-3"> <div class="col-12 grid-margin stretch-card"> <div class="card"> <div class="card-body"> <div id="registerInformation"></div> <div id="customInformation" class="e4usInformation" style="display:none"></div>  <form class="forms-sample"> <div class="control-group register_inputName"> <div class="form-group">  <p>'+
((__t=( model.text ))==null?'':__t)+
'</p> <div id="registerMailConfirmedSucces_div_paymentGateway"> </div> </div> </div> </form> </div> </div> </div> </div> </div> </div>';
}
return __p;
};
